<template>
  <section :class="classes">
    <font-awesome-icon
      class="cordel-alert-icon"
      :icon="iconized"
    />

    <span class="cordel-alert-content">
      <typography-title
        v-if="$slots.title"
        class="cordel-alert-title"
        hierarchy="h3"
      >
        <slot name="title" />
      </typography-title>

      <p class="cordel-alert-paragraph">
        <slot>
          Algo deu errado! Por favor, verifique os campos preenchidos e tente novamente.
        </slot>
      </p>
    </span>

    <span
      v-if="$slots.action"
      class="cordel-alert-action"
    >
      <slot name="action" />
    </span>
  </section>
</template>

<script>
  import TypographyTitle from '@cordel/components/Typography/Title.vue';

  const COLORS = ['danger', 'success', 'info'];

  export default {
    name: 'CordelContextAlert',
    components: {
      TypographyTitle,
    },
    props: {
      big: {
        type: Boolean,
        default: false,
      },
      light: {
        type: Boolean,
        default: false,
      },
      color: {
        type: String,
        default: COLORS[0],
        validator(value) {
          return COLORS.includes(value);
        },
      },
      icon: {
        type: String,
        default: null,
      },
    },
    computed: {
      classes() {
        const classes = [
          'cordel-alert',
          `color--${this.color}`,
        ];

        if (this.big) {
          classes.push('variant--big');
        }

        if (this.light) {
          classes.push('variant--light');
        }

        return classes;
      },
      iconized() {
        return this.icon || ({
          success: 'circle-check',
        })[this.color] || 'exclamation-circle';
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .cordel-alert {
    align-items: center;
    border-left: var(--cordel-spacing-xxxs) solid var(--cordel-color-alert-danger);
    background-color: var(--cordel-color-constant-dark);
    color: var(--cordel-color-constant-light);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    line-height: var(--cordel-line-height-l);
    padding: var(--cordel-spacing-xxs);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      font-size: var(--cordel-font-size-s);
    }
  }

  .variant--big {
    padding: var(--cordel-spacing-xxxl) var(--cordel-spacing-blaster);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: var(--cordel-spacing-s);
    }
  }

  .variant--light {
    background-color: var(--cordel-color-highlight-light);
    color: var(--cordel-color-constant-dark);

    &.color--success {
      border-left-color: var(--cordel-color-highlight-dark);
    }

    &.color--info {
      border-left-color: var( --cordel-color-alert-information);
    }

    &.color--warning {
      border-left-color: var( --cordel-color-alert-warning);
    }
  }

  .cordel-alert-icon {
    color: var(--cordel-color-alert-danger);
    margin-right: var(--cordel-spacing-xxxs);

    .variant--big & {
      font-size: 1.6em;
      margin-right: var(--cordel-spacing-xl);

      @media all and (max-width: $cordel-breakpoint-mobile) {
        margin-right: var(--cordel-spacing-s);
      }
    }

    .color--success & {
      color: var(--cordel-color-alert-success);
    }

    .variant--light.color--success & {
      color: var(--cordel-color-highlight-success-dark);
    }

    .color--info & {
      color: var(--cordel-color-alert-information);
    }

    .variant--light.color--info & {
      color: var(--cordel-color-alert-information-dark);
    }

    .color--warning & {
      color: var(--cordel-color-alert-warning);
    }

    .variant--light.color--warning & {
      color: var(--cordel-color-alert-warning-dark);
    }
  }

  .color--success {
    border-left-color: var(--cordel-color-alert-success);
  }

  .color--info {
    border-left-color: var( --cordel-color-alert-information);
  }

  .color--warning {
    border-left-color: var( --cordel-color-alert-warning);
  }

  .cordel-alert-title {
    color: inherit;
  }

  .cordel-alert-content {
    flex: 1;
  }

  .cordel-alert-action {
    margin-left: var(--cordel-spacing-giga);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      flex-wrap: wrap;
      margin: var(--cordel-spacing-xxxs) 0 0;
      width: 100%;
    }
  }
</style>
